import { faCircleXmark, faRedo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert, Button } from '@orobix/orobix-fe-components'
import i18next from 'i18next'

import { useStyles } from './IngestionStatusBanner.styles'

export const ErrorBanner = ({ onTryAgain }: { onTryAgain: () => void }) => {
  const classes = useStyles()
  return (
    <Alert type="info" withBorder>
      <span className={classes.icon}>
        <FontAwesomeIcon icon={faCircleXmark} />
      </span>
      {`${i18next.t(
        'An error occurred while fetching sync data status. Please try again or contact the support.'
      )}`}
      <span className={classes.tryAgain}>
        <Button
          type="default"
          label={i18next.t('Try again')}
          title={i18next.t('Try again')}
          size="sm"
          icon={<FontAwesomeIcon icon={faRedo} />}
          onClick={() => onTryAgain()}
        />
      </span>
    </Alert>
  )
}
